module.exports = {
      id: "share-youtube-usage",
      viewBox: "0 0 44 45",
      url: __webpack_public_path__ + "svg-sprite-1d11361007108583c67c4a96e18e035a.svg#share-youtube",
      toString: function () {
        return this.url;
      }
    }